import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'clearTableCurrentRow',
    position: [ButtonPosition.tableToolArea, ButtonPosition.tableBatchArea],
    // getDefaultProps: () => {
    //   return {
    //   };
    // },
    action: (config) => {
        const { buttonConfig, _context } = config || {};
        const { options = {} } = buttonConfig;
        const { _bindTable } = options || {};
        function handleOneTable(id) {
            if (typeof id === 'string') {
                const table = _context.$(id);
                table?.setDataSource?.({
                    __tableCurrentRow__: undefined,
                });
            }
        }
        if (_bindTable && _context) {
            if (Array.isArray(_bindTable)) {
                _bindTable.forEach((item) => {
                    handleOneTable(item);
                });
            }
            else {
                handleOneTable(_bindTable);
            }
        }
        return Promise.resolve();
    },
};
